import { createFileRoute, redirect } from '@tanstack/react-router'
import { SnapshotsPage } from '../pages/SnapshotsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/snapshots')({
    component: SnapshotsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
